/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_EmptyInputs */

const en_cc_empty = /** @type {(inputs: Cc_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are no scheduled or live meetings you can access. Create a meeting in KerjaBareng first.`)
};

const id_cc_empty = /** @type {(inputs: Cc_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada meeting terjadwal atau aktif yang boleh Anda akses. Buat meeting di KerjaBareng terlebih dahulu.`)
};

/**
* | output |
* | --- |
* | "There are no scheduled or live meetings you can access. Create a meeting in KerjaBareng first." |
*
* @param {Cc_EmptyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_empty = /** @type {((inputs?: Cc_EmptyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_EmptyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_empty(inputs)
	return en_cc_empty(inputs)
});